module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e98"
    }
  }, [_c('b', [_vm._v("ZONDERVAN")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e100"
    }
  }, [_c('i', [_vm._v("The Miracle")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e105"
    }
  }, [_vm._v("Copyright © 2007 by Gilbert Morris")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e2g05"
    }
  }, [_vm._v("All rights reserved under International and Pan-American Copyright Conventions. By payment of the required fees, you have been granted the non-exclusive, non-transferable right to access and read the text of this e-book on-screen.  No part of this text may be reproduced, transmitted, down-loaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented, without the express written permission of Zondervan.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e2y10"
    }
  }, [_vm._v("ePub Edition January 2009 ISBN: 978-0-310-54034-2\n\n")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e2e10"
    }
  }, [_vm._v("Requests for information should be addressed to:")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e212"
    }
  }, [_vm._v("Zondervan, "), _c('i', [_vm._v("Grand Rapids, Michigan 49530")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e114"
    }
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e116"
    }
  }, [_vm._v("Morris, Gilbert.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e118"
    }
  }, [_vm._v("The miracle / Gilbert Morris.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e120"
    }
  }, [_vm._v("p. cm. — (Singing River series ; bk. 3)")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e123"
    }
  }, [_vm._v("ISBN-13: 978-0-310-25234-4\n")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e125"
    }
  }, [_vm._v("1. Depressions — 1929 — United States — Fiction. 2. Domestic fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e127"
    }
  }, [_vm._v("PS3563.O8742M57 2007")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e129"
    }
  }, [_vm._v("813'.54 — dc22")]), _vm._v(" "), _c('p', {
    staticClass: "crtr",
    attrs: {
      "id": "d12e131"
    }
  }, [_vm._v("2006033495")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e134"
    }
  }, [_vm._v("Published in association with the literary agency of Alive Communications, Inc., 7680 Goddard Street, Suite 200, Colorado Springs, CO 80920.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e136"
    }
  }, [_vm._v("All Scripture quotations, unless otherwise indicated, are taken from the "), _c('i', [_vm._v("King James ")]), _c('i', [_vm._v("Version")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e143"
    }
  }, [_vm._v("Some of the poems in this book first appeared in "), _c('i', [_vm._v("Those Who Knew Him: Profiles of Christ ")]), _c('i', [_vm._v("in Verse")]), _vm._v(", published by Fleming H. Revell, copyright © by Gilbert Morris 1997. Used by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e150"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means — electronic, mechanical, photocopy, recording, or any other — except for brief quotations in printed reviews, without the prior permission of the publisher.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e160"
    }
  }, [_vm._v("06 07 08 09 10 11 12 "), _c('img', {
    attrs: {
      "alt": "Bullet",
      "id": "d12e162",
      "src": "images/Bullet.jpg"
    }
  }), _vm._v(" 20 19 18 17 16 15 14 13 12 11 10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f403921","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Morr_9780310252344_epub_c3_r1.vue
// module id = 66
// module chunks = 0